module.exports = __webpack_public_path__ + "static/media/Denmark.125ad7be.png";